import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'loadingLabel'
	| 'recommendedSpaces'
	| 'moreMenuDeleteLabel'
	| 'moreMenuRenameLabel'
	| 'moreMenuLabel'
	| 'cancelRenameLabel'
	| 'confirmRenameLabel'
	| 'viewAllSpacesLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		loadingLabel: {
			id: 'ai-mate.rovo-navigation.space-items.loading',
			defaultMessage: 'Loading spaces\u2026',
			description: 'Loading state label shown while the list of spaces is being fetched.',
		},
		recommendedSpaces: {
			id: 'ai-mate.rovo-navigation.space-items.recommended-spaces',
			defaultMessage: 'Recommended spaces',
			description: 'Button label for the recommended spaces menu item in the spaces list.',
		},
		moreMenuDeleteLabel: {
			id: 'ai-mate.rovo-navigation.space-items.more-menu.delete',
			defaultMessage: 'Delete',
			description: 'Menu item label in the space item three-dot more menu. Deletes the space.',
		},
		moreMenuRenameLabel: {
			id: 'ai-mate.rovo-navigation.space-items.more-menu.rename',
			defaultMessage: 'Rename',
			description: 'Menu item label in the space item three-dot more menu. Renames the space.',
		},
		moreMenuLabel: {
			id: 'ai-mate.rovo-navigation.space-items.more-menu.label',
			defaultMessage: 'More options',
			description: 'Accessible label for the three-dot more options button on a space item.',
		},
		cancelRenameLabel: {
			id: 'ai-mate.rovo-navigation.space-items.more-menu.cancel-rename',
			defaultMessage: 'Cancel rename',
			description: 'Accessible label for the cancel button in the inline space rename form.',
		},
		confirmRenameLabel: {
			id: 'ai-mate.rovo-navigation.space-items.more-menu.confirm-rename',
			defaultMessage: 'Confirm rename',
			description: 'Accessible label for the confirm button in the inline space rename form.',
		},
		viewAllSpacesLabel: {
			id: 'rovo-navigation.side-navigation.space-items.viewAllSpacesLabel',
			defaultMessage: 'View all spaces',
			description:
				'Label for the "View all spaces" menu item shown at the bottom of the Spaces section in the side nav. Clicking the link navigates the user to the fullscreen "Browse spaces" page.',
		},
	});

export default message;
